import React from "react";

import { StepIndicator, Heading } from "@telia/teddy";
import classnames from "classnames";
import { connect } from "react-redux";
import { useLocation, Outlet } from "react-router-dom";
import { TRANSFER_OWNERSHIP_LABELS, TRANSFER_OWNERSHIP_LINKS } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { ConnectedAlert, ProgressBar } from "../../../../components";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import TEXT from "../../../text-consts";
import ContinueSection from "../../molecules/ContinueSection/ContinueSection";
import "./TransferOwnershipPage.less";

function locationToStepIndicatorIndex(path: (typeof TRANSFER_OWNERSHIP_LINKS)[number]) {
    const index = TRANSFER_OWNERSHIP_LINKS.indexOf(path);
    return Math.max(index, 0);
}

interface TransferOwnershipPage {
    className?: string;
    isFetchingData?: boolean;
}

const TransferOwnershipPage: React.FC<TransferOwnershipPage> = ({ className = "", isFetchingData }) => {
    const location = useLocation();
    return (
        <div
            className={classnames("transfer-ownership-page", {
                [className]: className,
            })}
        >
            <div className="transfer-ownership-page__heading-container" data-cy="transfer-ownership">
                <span className="transfer-ownership-page__step-indicator" data-cy="transfer-ownership-step-indicator">
                    <StepIndicator
                        index={locationToStepIndicatorIndex(
                            location.pathname as (typeof TRANSFER_OWNERSHIP_LINKS)[number],
                        )}
                        numberOfSteps={4}
                        labels={TRANSFER_OWNERSHIP_LABELS}
                        links={TRANSFER_OWNERSHIP_LINKS}
                        kind="purple"
                    />
                </span>
                <span className="transfer-ownership-page__heading">
                    <Heading mb="100" as="h1" variant="title-600">
                        {TEXT.PAGE_HEADING}
                    </Heading>
                </span>
            </div>
            <ProgressBar isFetchingData={isFetchingData} standByColor="light-grey" />
            <ConnectedAlert />
            <div className="transfer-ownership-page__content">
                <Outlet />
                <ContinueSection isReadyToContinue={true} path={location.pathname} />
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isFetchingData: LOADING_SELECTORS.isLoading(state),
});

export default connect(mapStateToProps)(TransferOwnershipPage);
